module.exports = __webpack_public_path__ + "img/duPontAnalysis2.5c992afe.png";